import React from 'react';
import { TransactionRow, TransactionSummary } from 'anf-core-react';
import TmntHtml from '../Common/Text/TmntHtml';
import TmntText from '../Common/Text/TmntText';
import { transactionSummaryProps } from './props';

export default function OrderTotalSummary({ summary }) {
  const {
    isNegative, itemLabel, priceLabel, footer, rows, number,
  } = summary;

  return (
    <TransactionSummary
      isNegative={isNegative}
      itemColumnLabel={<TmntText tmnt={itemLabel} />}
      priceColumnLabel={<TmntText tmnt={priceLabel} />}
      itemSummaryLabel={footer?.label ? <TmntText tmnt={footer.label} /> : null}
      priceSummaryLabel={footer?.price ? <TmntHtml tmnt={{ key: '', value: footer.price }} /> : null}
    >
      {rows.map(({ label, price, negative }) => (
        <TransactionRow
          key={`${number}_${label?.value}`}
          itemLabel={<TmntText tmnt={label} />}
          priceLabel={<TmntHtml tmnt={{ key: '', value: price }} />}
          isNegative={negative}
        />
      ))}
    </TransactionSummary>
  );
}

OrderTotalSummary.propTypes = {
  summary: transactionSummaryProps,
};

OrderTotalSummary.defaultProps = {
  summary: null,
};
